import { basicInitialState } from '../_utils/basicInitialState';
import { TReportsState } from './reports';

export const reportsInitialState: TReportsState = {
  ...basicInitialState,
  referenceReports: null,
  reports: null,
  isTouched: false,
};
